import {Reducer} from 'redux'
import {CoreActionTypes, CoreState} from "./types";
import {LoggerService} from "../logger/LoggerService";


// Type-safe initialState!
const initialState: CoreState = {
	logs: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<CoreState> = (state = initialState, action) => {
	switch (action.type) {
		case CoreActionTypes.LOG_CHANGED: {
			return { ...state, logs: [ ...LoggerService.getLogs() ]}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as CoreReducer }
